import React from 'react';
import PropTypes from 'prop-types';
import FooterLinks from '../FooterLinks';
import ListWrapper from './styled/ListWrapper';
import { Desktop, Mobile } from '../../MediaQuery';

const LinkGroupList = ({ showSection, links, code }) => {
  return (
    <>
      <Mobile>
        <>
          {showSection && (
            <ListWrapper>
              <FooterLinks links={links} code={code} />
            </ListWrapper>
          )}
        </>
      </Mobile>
      <Desktop>
        <FooterLinks links={links} code={code} />
      </Desktop>
    </>
  );
};

LinkGroupList.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({ url: PropTypes.string, link: PropTypes.string })).isRequired,
  showSection: PropTypes.bool,
  code: PropTypes.string.isRequired,
};

export default LinkGroupList;
